/** @clearscore/constants.request-statuses v2.2.8: 2022-12-12 17:54 (assemble v5.5.1) **/
var INITIAL = 'initial';
var SUCCESS = 'success';
var ERROR = 'error';
var PENDING = 'pending';
export { ERROR, INITIAL, PENDING, SUCCESS };